import React, { useEffect, useRef, useState } from 'react';
import {
  ContentContainer,
  DashboardContainer,
  MetricsGrid,
  Title,
  MetricCard,
  MetricValue,
  MetricLabel,
} from './analytics.style';
import { useNavigate } from 'react-router-dom';
import { AdminAnalyticsPie } from '../../../components/chart';

// Reusable Metric Tile Component
const MetricTile = ({ value, label, id, detailsView }) => (
  <MetricCard role="article" aria-labelledby={`${id}-label`} tabIndex="0" onClick={detailsView}>
    <MetricValue aria-describedby={`${id}-label`}>{value.toLocaleString()}</MetricValue>
    <MetricLabel id={`${id}-label`}>{label}</MetricLabel>
  </MetricCard>
);

// Main Analytics Component
const AnalyticsDashboard = () => {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const navigate = useNavigate();

  const metricsData = [
    { id: 'total-enquires', value: 890, label: 'Total Enquires' },
    { id: 'pre-lodge-report', value: 230, label: 'Pre lodge Report' },
    { id: 'final-report', value: 100, label: 'Final Report' },
    { id: 'cancel-da', value: 128, label: 'Cancel DA' },
    { id: 'reviewing', value: 450, label: 'Reviewing' },
  ];

  const handleDeatailsView = () => {
    navigate('/analyticsDetails');
  };

  useEffect(() => {
    // In a real application, you would load ArcGIS JS API here
    // For demo purposes, we'll simulate the map loading
    const timer = setTimeout(() => {
      setMapLoaded(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <DashboardContainer>
      <ContentContainer id="main-content">
        <Title>Analytics Overview</Title>
        <section aria-labelledby="metrics-title">
          <h2 id="metrics-title" className="sr-only">
            Key Metrics
          </h2>
          <MetricsGrid role="group" aria-label="Key performance metrics">
            {metricsData.map((metric) => (
              <MetricTile
                key={metric.id}
                id={metric.id}
                value={metric.value}
                label={metric.label}
                detailsView={handleDeatailsView}
              />
            ))}
          </MetricsGrid>
        </section>
        <AdminAnalyticsPie />
      </ContentContainer>

      {/* Hidden styles for screen readers */}
      <style jsx>{`
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </DashboardContainer>
  );
};

export default AnalyticsDashboard;
